module.exports = __webpack_public_path__ + "static/media/answer.b3f9b5af.svg";